// angular
// 	.module("HeroPRO")
// 	.controller("NotificationMenuController", notificationMenuController);

import _ from 'lodash';
import './notificationMenu.scss';

/* @ngInject */
export default function notificationMenuController($scope, NotificationCenterFactory) {
    const vm = this;

    vm.menuHeader = 'Looks like we need your...';
    vm.toggleClicked = false;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.menuItemOnClick = function (notification) {
        const currentNotification = NotificationCenterFactory.getActiveNotification();
        if(currentNotification.CanBeDismissedByUser === false) {
            return;
        }

    	if(notification.isComplete !== true) {
    		_.each(vm.notifications, function(notification){
    			if(notification.isActive === true) {
    				notification.isActive = false;
    			}
    		});
    		notification.isActive = true;
    	}

    	//NotificationCenterFactory.setActiveTemplate(notification.template);
    	NotificationCenterFactory.setActiveNotification(notification);
    	$scope.$emit("notificationsMenuClick");

    };

    vm.toggle = function () {
	    vm.toggleClicked = !vm.toggleClicked;
	    $scope.$emit('notificationMenuToggleClick', { toggleClicked: vm.toggleClicked });
    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */

    function init() {

    }

    /* -----  End of Private Functions  ------*/

    /*= ========================================
	 =            Pub/Sub Handlers            =
	 ========================================= */


    /* -----  End of Pub/Sub Handlers  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/notificationMenu/notificationMenuController.js